@include spacers();

:host {
  display: contents;
}

.container {
  font-family: inherit;
  a {
    display: inline-block;
    &.full-width-true {
      display: block;
    }
  }
  &.centered-true {
    text-align: center;
  }
}

.button {
    @include button();
    &.size-small {
      @include button-small();
    }

    &.button.rounded-true {
      @include button-rounded();
    }
}

@each $brand, $colour in $brandColours {
  .button-#{$brand} {
    color: $colour-white; // may be overridden by following rules. Later CSS rules have priority.
    background-color: $colour;
    border-color: $colour;
    &:hover {
      color: $colour;
      background-color: $colour-white; // may be overriden by following rules
    }
  }
}

.button-secondary {
  color: $colour-black;
  &:hover {
    color: $colour-black;
    background-color: $colour-white;
    border-color: $colour-black;
  }
}

.button-brand-grey {
  color: $colour-white;
  &:hover {
    background-color: $colour-black;
  }
}

.button-brand-mhf-turquoise {
  &:hover {
    background-color: $colour-black;
  }
}

.button-brand-afa-pink {
  &:hover {
    background-color: $colour-black;
  }
}

.button-white {
  color: $colour-primary-blue;
  &:hover {
    color: $colour-black;
    background-color: $colour-secondary-green;
  }
}

.button-philco-gray-90 {
  @include font-size-philco-medium();
  color: $colour-philco-white;
  &:hover {
    color: $colour-philco-gray-90;
    background-color: $colour-philco-orange;
  }
}

.button-philco-orange {
  @include font-size-philco-medium();
  color: $colour-philco-gray-90;
  &:hover {
    color: $colour-philco-white;
    background-color: $colour-philco-gray-90;
  }
}

.button-philco-white {
  @include font-size-philco-medium();
  color: $colour-philco-gray-90;
  &:hover {
    color: $colour-philco-gray-90 !important;
    background-color: $colour-philco-orange !important;
  }
}

.container.philco a {
  border-color: transparent;
}

.container.disabled.philco .button {
  cursor: not-allowed;
  background-color: $colour-philco-gray-30 !important;

  color: $colour-philco-white;
  &:hover {
    background-color: $colour-philco-gray-30;
    color: $colour-philco-white;
  }
}

.button-black {
  color: $colour-white;
  &:hover {
    background-color: $colour-white;
  }
}

.button-grey-extra-light {
  color: $colour-black;
  &:hover {
    background-color: $colour-black;
  }
}

.button-grey-light {
  color: $colour-black;
  &:hover {
    background-color: $colour-black;
  }}

.button-grey-medium {
  color: $colour-white;
  &:hover {
    background-color: $colour-white;
  }
}

.button-grey-dark {
  color: $colour-white;
  &:hover {
    background-color: $colour-white;
  }
}

.button-rounded {
    @include button-rounded();
 }

 @each $brand, $colour in $brandColours {
    .button-clear-#{$brand} {
        color: $colour;
        background-color: transparent;
        text-decoration: underline;
        border: 0;
        padding-left: 0;
        padding-right: 0;
        &:hover {
          color: $colour;
          text-decoration: none;
          background-color: transparent;
        }
    }
}
